/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, November 21st 2021, 3:05:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import {
  APIMany2ManyTransferListFormInput,
  ConcreteAPIMany2ManyTransferListFormInputProps,
  APIMany2ManyCheckBoxFormInput,
  ConcreteAPIMany2ManyInputProps,
  APIMany2OneSelectFormInput,
  ConcreteAPIMany2OneSelectFormInputProps,
} from "ui-widgets";
import { Department } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import ListItemText from "@mui/material/ListItemText";
import GroupsIcon from "@mui/icons-material/Groups";

export const DepartmentsTransferListInput = <T,>(
  props: ConcreteAPIMany2ManyTransferListFormInputProps<T, Department>
) => (
  <APIMany2ManyTransferListFormInput<T, Department>
    apiServicePath={APISERVICEPATHS.departments}
    itemIdProperty="id"
    getOptionComponent={(option) => <ListItemText primary={option.name} />}
    {...props}
  />
);

export const DepartmentsCheckboxesInput = <T,>(props: ConcreteAPIMany2ManyInputProps<T, Department>) => (
  <APIMany2ManyCheckBoxFormInput<T, Department>
    apiServicePath={APISERVICEPATHS.departments}
    itemIdProperty="id"
    getOptionComponent={(option) => <ListItemText primary={option.name} />}
    {...props}
  />
);

export const SingleDepartmentSelectInput = <T,>(props: ConcreteAPIMany2OneSelectFormInputProps<T, Department>) => (
  <APIMany2OneSelectFormInput<T, Department>
    apiServicePath={APISERVICEPATHS.departments}
    itemIdProperty="id"
    label={props.label ?? "Select Department"}
    getOptionLabel={(option) => option.name}
    inputStartAdornment={<GroupsIcon color="primary" />}
    {...props}
  />
);
